/* eslint-disable no-magic-numbers */
/* eslint-disable default-case */
/* eslint-disable complexity */

import React, { ReactNode, useCallback, useRef, useState } from 'react';

import { ActionButtons } from './components/action-buttons';
import { DocumentationDrawer } from './components/documentation-drawer';
import {
  FormulaEditorLexical,
  FormulaEditorLexicalHandle
} from '../../../../ui/data-builder/formula-content-form/formula-editor-lexical/formula-editor';
import { FormulaMethodTopBar } from './components/formula-method-top-bar';
import { FormulaReferenceOption } from '../../../../utils/formulas/types';
import { localizeFormula } from '../../../../utils/formulas/i18n-utils';
import { NOT_CLICKABLE_IDS } from './const';
import { PredictionHeaderProps, RepeatingPattern } from '../../types';

import * as styles from './formula.scss';

interface Props {
  formulaFrequencyOnDay: string;
  formulaFrequencyOnMonth: string;
  handleFormulaContentChange: (content: string) => void;
  handleFormulaFrequencyOnDayChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleFormulaFrequencyOnMonthChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleOutputFrequencyChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  initialEditorOptions: FormulaReferenceOption[];
  initialFormulaContent: string;
  message?: ReactNode;
  outputFrequency: RepeatingPattern | null;
  PredictionHeader: React.FunctionComponent<PredictionHeaderProps>;
}

export const FormulaMethod = ({
  PredictionHeader,
  handleFormulaContentChange,
  outputFrequency,
  handleOutputFrequencyChange,
  formulaFrequencyOnDay,
  handleFormulaFrequencyOnDayChange,
  formulaFrequencyOnMonth,
  handleFormulaFrequencyOnMonthChange,
  initialEditorOptions,
  initialFormulaContent,
  message
}: Props) => {
  const lexicalEditorRef = useRef<FormulaEditorLexicalHandle>(null);
  const [isOpenDocumentationDrawer, setIsOpenDocumentationDrawer] = useState(false);

  const handleHelpClick = useCallback(() => setIsOpenDocumentationDrawer(true), []);

  const handleHelpClose = useCallback(() => setIsOpenDocumentationDrawer(false), []);

  const handleActionClick = (action: string) => {
    const localizedAction = localizeFormula(action);
    lexicalEditorRef.current?.insertTextAtCursor(localizedAction);
  };

  if (!initialEditorOptions) {
    return null;
  }

  return (
    <div>
      <FormulaMethodTopBar
        formulaFrequencyOnDay={formulaFrequencyOnDay}
        formulaFrequencyOnMonth={formulaFrequencyOnMonth}
        handleFormulaFrequencyOnDayChange={handleFormulaFrequencyOnDayChange}
        handleFormulaFrequencyOnMonthChange={handleFormulaFrequencyOnMonthChange}
        handleHelpClick={handleHelpClick}
        handleOutputFrequencyChange={handleOutputFrequencyChange}
        hideFormulaControls={!!message}
        outputFrequency={outputFrequency}
        PredictionHeader={PredictionHeader}
      />
      {message ? (
        <div className={styles.message}>{message}</div>
      ) : (
        <>
          <FormulaEditorLexical
            ref={lexicalEditorRef}
            ariaLabel="Enter formula"
            autoFocus
            className={styles.editor}
            editorInputClassName={styles.lexicalEditorInput}
            initialEditorOptions={initialEditorOptions}
            initialFormulaContent={initialFormulaContent}
            nonSelectableOptionIds={NOT_CLICKABLE_IDS}
            onFormulaChange={handleFormulaContentChange}
          />
          <ActionButtons outputFrequency={outputFrequency} handleActionClick={handleActionClick} />
        </>
      )}

      <DocumentationDrawer isOpen={isOpenDocumentationDrawer} onClose={handleHelpClose} />
    </div>
  );
};
